module.exports = __webpack_public_path__ + "img/icon-youtube.dce176bc0172e880e3836ebd1cc30301.svg";